import { useEffect, useState } from "react";
import { Link } from "@tanstack/react-router";
import { Calculator, X, Sparkles } from "lucide-react";

const KEY = "mp:estimatePrompt:dismissed:v1";

export function EstimatePrompt() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    try {
      if (window.sessionStorage.getItem(KEY) === "1") return;
    } catch {
      /* ignore */
    }

    let shown = false;
    const show = () => {
      if (shown) return;
      shown = true;
      setOpen(true);
      window.removeEventListener("scroll", onScroll);
      window.clearTimeout(timer);
    };
    const onScroll = () => {
      if (window.scrollY > window.innerHeight * 1.2) show();
    };
    const timer = window.setTimeout(show, 18000);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.clearTimeout(timer);
    };
  }, []);

  const dismiss = () => {
    setOpen(false);
    try {
      window.sessionStorage.setItem(KEY, "1");
    } catch {
      /* ignore */
    }
  };

  if (!open) return null;

  return (
    <div
      className="fixed inset-x-0 bottom-0 z-50 px-4 pb-4 sm:px-6 sm:pb-6 pointer-events-none animate-fade-in"
      role="dialog"
      aria-modal="false"
      aria-labelledby="estimate-prompt-title"
    >
      <div className="pointer-events-auto mx-auto max-w-xl relative bg-noir border border-gold/40 shadow-[0_30px_80px_-20px_oklch(0.74_0.11_82/0.4)] p-5 sm:p-6 flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-6">
        <span className="absolute -top-px left-6 right-6 h-px bg-gradient-to-r from-transparent via-gold to-transparent" />
        <div className="hidden sm:flex size-12 shrink-0 border border-gold/40 items-center justify-center">
          <Calculator className="size-5 text-gold" strokeWidth={1.25} />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.3em] text-gold font-serif italic mb-1.5">
            <Sparkles className="size-3" /> Instant Estimate
          </div>
          <h3
            id="estimate-prompt-title"
            className="font-serif text-xl sm:text-2xl leading-tight text-ivory"
          >
            Get a real price range in under two minutes.
          </h3>
          <p className="text-xs text-ivory/55 mt-1.5 leading-relaxed">
            Five quick questions — gallons, hours, and total, using our estimators' formulas.
          </p>
        </div>
        <div className="flex items-center gap-3 shrink-0">
          <Link
            to="/estimate"
            onClick={dismiss}
            className="inline-flex items-center gap-2 bg-gradient-to-br from-gold to-[oklch(0.62_0.10_78)] text-noir px-5 py-3 text-[11px] uppercase tracking-[0.25em] font-semibold border border-gold-hi/40 hover:brightness-110 transition"
          >
            Start
          </Link>
          <button
            type="button"
            onClick={dismiss}
            aria-label="Dismiss"
            className="p-2 text-ivory/50 hover:text-ivory transition-colors"
          >
            <X className="size-4" />
          </button>
        </div>
      </div>
    </div>
  );
}